/******************************************************************
 * Archivo : client/src/mutations/updateRole.js
 * Proyecto: CB30
 * Módulo  : Administración de Roles
 *
 * Propósito:
 * Mutación para actualizar un Rol.
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  mutation UpdateRole(
    $id: ID!
    $code: String!
    $label: String!
    $description: String
    $permissions: [ID]
    $active: Boolean!
  ) {

    updateRole(
      id: $id
      code: $code
      label: $label
      description: $description
      permissions: $permissions
      active: $active
    ) {

      id
      code
      label
      description
      active

    }

  }
`;


// WEBPACK FOOTER //
// ./src/mutations/updateRole.js